import { render } from "./OddsMatchContentOverview.vue?vue&type=template&id=f114d2f4"
import script from "./OddsMatchContentOverview.vue?vue&type=script&lang=js"
export * from "./OddsMatchContentOverview.vue?vue&type=script&lang=js"

import "./OddsMatchContentOverview.vue?vue&type=style&index=0&id=f114d2f4&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__